export const SPRINT_SHOW_RESULT_DELAY = 1000;

export const SPRINT_START_SCREEN = 'SPRINT_START_SCREEN';
export const SPRINT_STATISTIC_SCREEN = 'SPRINT_STATISTIC_SCREEN';
export const SPRINT_GAME_SCREEN = 'SPRINT_GAME_SCREEN';
export const SPRINT_END_SCREEN = 'SPRINT_END_SCREEN';
